



















import { Component, Prop, Vue } from 'vue-property-decorator'

import { Action } from 'vuex-class'

import { ModalState, OptionGroup, OptionGroupResourcePayload } from '@/models'

import OptionGroupForm from './OptionGroupForm.vue'

@Component({
  components: {
    OptionGroupForm
  }
})
export default class CreateOptionGroupModal extends Vue {
  @Prop({ type: ModalState, required: true })
  readonly modalState!: ModalState

  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  data: OptionGroupResourcePayload | null = null
  isValid = false

  @Action('menu/createOptionGroup')
  createOptionGroup!: (payload: OptionGroupResourcePayload) => Promise<OptionGroup>

  cancel () {
    this.modalState.reset()

    this.data = null

    this.$emit('cancel')
  }

  async submit () {
    if (this.data === null || !this.isValid) {
      return
    }

    try {
      const optionGroup = await this.modalState.handle(
        this.createOptionGroup(this.data)
      )

      this.$router.push({
        name: 'OptionGroupDetails',
        params: {
          itemGroupId: this.itemGroupId.toString(),
          optionGroupId: optionGroup.id.toString()
        }
      })
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível criar novo opcional.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  submitAndClose () {
    this.modalState.isActive = false
    this.submit()
  }
}
